/**
 * Ecran de victoire : parchemin "GAGNÉ" discret en surimpression (cahier des
 * charges §7 — la cascade de cartes 3D joue derriere), avec temps et nombre
 * de coups, puis Nouvelle donne / Rejouer cette donne / Menu.
 */
export class VictoryScreen {
  private el: HTMLDivElement;

  constructor(
    root: HTMLElement,
    onNewGame: () => void,
    onReplaySame: () => void,
    onMenu: () => void,
  ) {
    this.el = document.createElement("div");
    this.el.id = "victory-screen";
    this.el.className = "game-over-screen";
    this.el.hidden = true;
    this.el.innerHTML = `
      <div class="parchment-panel victory-panel">
        <h2 class="win">GAGNÉ !</h2>
        <p class="victory-stats" id="victory-stats"></p>
        <p class="victory-flavor">« La donne est faite, la chope est méritée. »</p>
        <div class="menu-buttons">
          <button class="wood-button primary" id="victory-new">Nouvelle donne</button>
          <button class="wood-button secondary" id="victory-replay">Rejouer cette donne</button>
          <button class="wood-button secondary" id="victory-menu">Menu</button>
        </div>
      </div>
    `;
    root.appendChild(this.el);

    this.el.querySelector<HTMLButtonElement>("#victory-new")!.addEventListener("click", () => {
      this.hide();
      onNewGame();
    });
    this.el.querySelector<HTMLButtonElement>("#victory-replay")!.addEventListener("click", () => {
      this.hide();
      onReplaySame();
    });
    this.el.querySelector<HTMLButtonElement>("#victory-menu")!.addEventListener("click", () => {
      this.hide();
      onMenu();
    });
  }

  show(timeSeconds: number, moves: number): void {
    const m = Math.floor(timeSeconds / 60);
    const s = timeSeconds % 60;
    this.el.querySelector<HTMLElement>("#victory-stats")!.textContent =
      `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")} — ${moves} coups`;
    this.el.hidden = false;
  }

  hide(): void {
    this.el.hidden = true;
  }
}

/**
 * Ecran de defaite : plus aucun coup possible pour la donne en cours.
 * Message bref, puis Recommencer (nouvelle donne) / Accueil.
 */
export class LossScreen {
  private el: HTMLDivElement;

  constructor(root: HTMLElement, onRestart: () => void, onHome: () => void) {
    this.el = document.createElement("div");
    this.el.id = "loss-screen";
    this.el.className = "game-over-screen";
    this.el.hidden = true;
    this.el.innerHTML = `
      <div class="parchment-panel victory-panel">
        <h2 class="lose">PERDU</h2>
        <p class="victory-flavor">Plus aucun coup possible pour cette donne.</p>
        <div class="menu-buttons">
          <button class="wood-button primary" id="loss-restart">Recommencer</button>
          <button class="wood-button secondary" id="loss-home">Accueil</button>
        </div>
      </div>
    `;
    root.appendChild(this.el);

    this.el.querySelector<HTMLButtonElement>("#loss-restart")!.addEventListener("click", () => {
      this.hide();
      onRestart();
    });
    this.el.querySelector<HTMLButtonElement>("#loss-home")!.addEventListener("click", () => {
      this.hide();
      onHome();
    });
  }

  show(): void {
    this.el.hidden = false;
  }

  hide(): void {
    this.el.hidden = true;
  }
}
